import { render, staticRenderFns } from "./UserConsumeReport.vue?vue&type=template&id=c18b6dfe&scoped=true&"
import script from "./UserConsumeReport.vue?vue&type=script&lang=js&"
export * from "./UserConsumeReport.vue?vue&type=script&lang=js&"
import style0 from "./UserConsumeReport.vue?vue&type=style&index=0&id=c18b6dfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18b6dfe",
  null
  
)

export default component.exports